import { KnowledgeChannel } from './types';

export const knowledgeLocales = ['en-gb', 'fr-fr'] as const;
export type KnowledgeLocale = (typeof knowledgeLocales)[number];

export function isKnowledgeLocale(locale: string): locale is KnowledgeLocale {
  return knowledgeLocales.includes(locale as KnowledgeLocale);
}

export function resolveKnowledgeLocale(locale: string | undefined): KnowledgeLocale {
  if (locale === 'fr-fr') {
    return 'fr-fr';
  }
  return 'en-gb';
}

export interface KnowledgeUiCopy {
  searchPlaceholder: string;
  searchButton: string;
  searchAriaLabel: string;
  home: string;
  homeAriaLabel: string;
  topicCatalog: string;
  topArticles: string;
  contactSupport: string;
  viewAll: (count: number) => string;
}

interface KnowledgeCopy {
  helpIndexTitle: string;
  helpIndexIntro: string;
  heroIndexTitle: string;
  heroIndexIntro: string;
  channelLabel: Record<KnowledgeChannel, string>;
  ui: KnowledgeUiCopy;
}

const copyByLocale: Record<KnowledgeLocale, KnowledgeCopy> = {
  'en-gb': {
    helpIndexTitle: 'How Can We Help?',
    helpIndexIntro: 'Find answers about booking, treatments, and your account.',
    heroIndexTitle: 'How Can We Help?',
    heroIndexIntro: 'Guidance for Urban practitioners using the Pro app.',
    channelLabel: {
      hero: 'Hero help',
      help: 'Help centre',
    },
    ui: {
      searchPlaceholder: 'Search...',
      searchButton: 'SEARCH',
      searchAriaLabel: 'Search articles',
      home: 'Home',
      homeAriaLabel: 'Home',
      topicCatalog: 'Topic Catalog',
      topArticles: 'Top Articles',
      contactSupport: 'Contact Support',
      viewAll: (count) => `View All (${count})`,
    },
  },
  'fr-fr': {
    helpIndexTitle: 'Comment pouvons-nous vous aider ?',
    helpIndexIntro: 'Réponses sur les réservations, les soins et votre compte.',
    heroIndexTitle: 'Aide Hero',
    heroIndexIntro: 'Guide pour les praticiens Urban utilisant l’application Pro.',
    channelLabel: {
      hero: 'Aide Hero',
      help: 'Centre d’aide',
    },
    ui: {
      searchPlaceholder: 'Rechercher...',
      searchButton: 'RECHERCHER',
      searchAriaLabel: 'Rechercher des articles',
      home: 'Page d’accueil',
      homeAriaLabel: 'Page d’accueil',
      topicCatalog: 'Liste des sujets',
      topArticles: 'Articles les plus lus',
      contactSupport: 'Contacter le support',
      viewAll: (count) => `Voir tout (${count})`,
    },
  },
};

export function getKnowledgeCopy(locale: string): KnowledgeCopy {
  return copyByLocale[resolveKnowledgeLocale(locale)];
}

export function getKnowledgeUiCopy(locale: string): KnowledgeUiCopy {
  return getKnowledgeCopy(locale).ui;
}

export const KNOWLEDGE_CONTACT_EMAIL = 'info@urban.co';
